import fetch from 'isomorphic-fetch';
import {Promise} from 'es6-promise';
import {
    getToken
} from '../utils/local-storage';
import {getCookie} from '../utils/cookies';

function addHeaders(options) {
    let headers = {};

    if (Object.prototype.toString.call(options.body) !== '[object FormData]') {

        headers['Content-Type'] = 'application/json';
    }

    const csrftoken = getCookie('csrftoken');
    if (csrftoken) {
        headers['X-CSRFToken'] = csrftoken;
    }

    const token = getToken();
    if (token) {
        headers['Authorization'] = `Token ${token}`;
    }

    return {
        ...options,
        headers: headers,
        credentials: 'same-origin', mode: 'cors'
    };
}

function callApi(url, options) {
    let opt = addHeaders(options);
    return fetch(url, opt).then((response) => {

        const contentType = response.headers.get('content-type');
        const isJson = contentType && contentType.indexOf('application/json') >= 0;

        if (response.status >= 200 && response.status < 300) {
            return isJson ? Promise.resolve(response.json()) : Promise.resolve(
                response.status === 204 ? null : response.body()
            );
        }

        const error = new Error(response.statusText || response.status, response.status);
        if (isJson) {
            return response.json().then((json) => {
                error.response = json;
                error.status = response.status;
                throw error;
            });
        }

        error.response = {
            message: 'Klaida. Mėginkite dar kartą',
            status: response.status
        };
        throw error;
    });
}

export function callGet(url) {
    return callApi(url, {
        method: 'GET'
    });
}

export function callPost(url, data) {
    return callApi(url, {
        method: 'POST',
        body: JSON.stringify(data)
    });
}

export function callUpdate(url, data) {
    return callApi(url, {
        method: 'PUT',
        body: JSON.stringify(data)
    });
}

export function callDelete(url) {
    return callApi(url, {
        method: 'DELETE'
    });
}

export function postFormData(url, data) {
    return callApi(url, {
        method: 'POST',
        body: data
    });
}

export function putFormData(url, data) {
    return callApi(url, {
        method: 'PUT',
        body: data
    });
}



// WEBPACK FOOTER //
// ./src/js/utils/api.js